import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};


const IncidentSummaryCard = () => {
  const incidentData = {
    name: "Service API Latency Spike: Payment Processing",
    type: "Performance Degradation",
    source: "Datadog Alert",
    severity: "Critical",
    status: "Investigating",
    playbookTriggered: "Payment Service Latency Incident Response (PSLIR)",
  };

  return (
    <Card className="shadow-sm border mt-4" style={cardShell}>
      <CardBody className="p-4">
        <h5 className="fw-bold mb-4">Incident Summary</h5>

        {[
          { label: "Name", value: incidentData.name },
          { label: "Type", value: incidentData.type },
          { label: "Source", value: incidentData.source },
        ].map((item, i) => (
          <Row className="mb-3" key={i}>
            <Col md={3}>
              <p className="text-muted mb-1" style={{ fontSize: "14px" }}>
                {item.label}
              </p>
            </Col>
            <Col md={9}>
              <p className="mb-1" style={{ fontSize: "14px" }}>
                {item.value}
              </p>
            </Col>
          </Row>
        ))}

        <Row className="mb-3">
          <Col md={3}>
            <p className="text-muted mb-1" style={{ fontSize: "14px" }}>
              Severity
            </p>
          </Col>
          <Col md={9}>
            <span
              className="badge"
              style={{
                backgroundColor: "#0000",
                color: "#dc3545",
                fontSize: "12px",
                padding: "4px 12px",
                borderRadius: "12px",
                border:"1px solid #dc3545"
              }}
            >
              {incidentData.severity}
            </span>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={3}>
            <p className="text-muted mb-1" style={{ fontSize: "14px" }}>
              Status
            </p>
          </Col>
          <Col md={9}>
            <span
              className="badge"
              style={{
                backgroundColor: "#0000",
                color: "#FF5B00",
                fontSize: "12px",
                padding: "4px 12px",
                borderRadius: "12px",
                border:"1px solid #FF5B00"
              }}
            >
              {incidentData.status}
            </span>
          </Col>
        </Row>

        <Row>
          <Col md={3}>
            <p className="text-muted mb-1" style={{ fontSize: "14px" }}>
              Playbook Triggered
            </p>
          </Col>
          <Col md={9}>
            <p className="mb-1" style={{ fontSize: "14px" }}>
              {incidentData.playbookTriggered}
            </p>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default IncidentSummaryCard;
